import { COLOR_BANTAMWEIGHT, COLOR_MINT, COLOR_PINK } from '../../../helpers/colors';

/**
 * scatter chart specific configurations
 * @type {Object}
 */
export const scatterChartConfiguration = {
  colors: [COLOR_BANTAMWEIGHT, COLOR_PINK, COLOR_MINT],
  plotOptions: {
    dataLabels: {
      enabled: true,
      format: '{point.name}',
    },
    scatter: {
      marker: {
        lineWidth: 1,
        radius: 6,
        symbol: 'circle',
      },
    },
  },
  tooltip: {
    shared: true,
    useHTML: true,
  },
};
